 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime~payslip":"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime~payslip","Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime":"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime","calculate_attendance":"calculate_attendance","payslip":"payslip","Employee~calculate_earning_deduction~calculate_overtime~department~payroll~position":"Employee~calculate_earning_deduction~calculate_overtime~department~payroll~position","Employee":"Employee","calculate_earning_deduction~company_currency~getstart":"calculate_earning_deduction~company_currency~getstart","calculate_earning_deduction":"calculate_earning_deduction","calculate_overtime":"calculate_overtime","department":"department","payroll":"payroll","position":"position","add_employee~basic_detail~hiring_detail":"add_employee~basic_detail~hiring_detail","add_employee":"add_employee","basic_detail":"basic_detail","hiring_detail":"hiring_detail","company_currency":"company_currency","getstart":"getstart","company_expat":"company_expat","company_payroll-rule":"company_payroll-rule","company_sso":"company_sso","company_tax":"company_tax","dashboard":"dashboard","document":"document","earning":"earning","template":"template"}[chunkId]||chunkId) + "." + {"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime~payslip":"2e642b8b","Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime":"276bc7ef","calculate_attendance":"a3cf844d","payslip":"483d8442","Employee~calculate_earning_deduction~calculate_overtime~department~payroll~position":"e676a1c5","Employee":"e9b79bc8","calculate_earning_deduction~company_currency~getstart":"ce0f0566","calculate_earning_deduction":"36e998cb","calculate_overtime":"28265b6e","department":"68e4e732","payroll":"5dbbfdfd","position":"4d99f11c","add_employee~basic_detail~hiring_detail":"530dee99","add_employee":"65312f3e","basic_detail":"a20c8be4","hiring_detail":"087f2e8f","company_currency":"0bd924a0","getstart":"4e8458c9","chunk-0f9c66d2":"d78e75dc","chunk-17a883c8":"024b5816","chunk-2f69fddb":"808084a3","chunk-3b13afec":"5b872003","chunk-037c452c":"bc6a9351","company_expat":"cef3aeed","chunk-4843d8af":"d1af019a","chunk-90467fac":"4cd66429","chunk-d40a3138":"7476c538","company_payroll-rule":"0b7baf3f","company_sso":"f4be70a7","company_tax":"1c076b49","dashboard":"491fd539","document":"11063bc1","earning":"d16c6bd9","template":"3282d327"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"calculate_attendance":1,"payslip":1,"Employee~calculate_earning_deduction~calculate_overtime~department~payroll~position":1,"Employee":1,"calculate_earning_deduction":1,"calculate_overtime":1,"department":1,"payroll":1,"position":1,"add_employee~basic_detail~hiring_detail":1,"add_employee":1,"basic_detail":1,"hiring_detail":1,"company_currency":1,"getstart":1,"chunk-0f9c66d2":1,"chunk-17a883c8":1,"chunk-3b13afec":1,"chunk-037c452c":1,"company_expat":1,"chunk-4843d8af":1,"chunk-90467fac":1,"chunk-d40a3138":1,"company_payroll-rule":1,"company_sso":1,"company_tax":1,"dashboard":1,"document":1,"earning":1,"template":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime~payslip":"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime~payslip","Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime":"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime","calculate_attendance":"calculate_attendance","payslip":"payslip","Employee~calculate_earning_deduction~calculate_overtime~department~payroll~position":"Employee~calculate_earning_deduction~calculate_overtime~department~payroll~position","Employee":"Employee","calculate_earning_deduction~company_currency~getstart":"calculate_earning_deduction~company_currency~getstart","calculate_earning_deduction":"calculate_earning_deduction","calculate_overtime":"calculate_overtime","department":"department","payroll":"payroll","position":"position","add_employee~basic_detail~hiring_detail":"add_employee~basic_detail~hiring_detail","add_employee":"add_employee","basic_detail":"basic_detail","hiring_detail":"hiring_detail","company_currency":"company_currency","getstart":"getstart","company_expat":"company_expat","company_payroll-rule":"company_payroll-rule","company_sso":"company_sso","company_tax":"company_tax","dashboard":"dashboard","document":"document","earning":"earning","template":"template"}[chunkId]||chunkId) + "." + {"Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime~payslip":"31d6cfe0","Employee~calculate_attendance~calculate_earning_deduction~calculate_overtime":"31d6cfe0","calculate_attendance":"0a1a05bb","payslip":"2e5f707a","Employee~calculate_earning_deduction~calculate_overtime~department~payroll~position":"e4b7b6aa","Employee":"f75def06","calculate_earning_deduction~company_currency~getstart":"31d6cfe0","calculate_earning_deduction":"9af58dda","calculate_overtime":"886f54bc","department":"81e4de84","payroll":"9d94b434","position":"72732cfc","add_employee~basic_detail~hiring_detail":"bb51e69b","add_employee":"f6f35cb1","basic_detail":"57a094bc","hiring_detail":"22dd8e51","company_currency":"b59b1afc","getstart":"ff63f88d","chunk-0f9c66d2":"063524ac","chunk-17a883c8":"aede5ab1","chunk-2f69fddb":"31d6cfe0","chunk-3b13afec":"41d00671","chunk-037c452c":"12d5d20f","company_expat":"12f42701","chunk-4843d8af":"fe609b69","chunk-90467fac":"6df42579","chunk-d40a3138":"2781b686","company_payroll-rule":"82ef9d31","company_sso":"d8982239","company_tax":"51915ccf","dashboard":"a8eb8bd3","document":"f790b584","earning":"2c63e0f6","template":"caa38065"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
